(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', function () { api.init(root); });
    else api.init(root);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var MAX_FRAGMENT = 7000, MAX_BODY = 4000;
  function parseHandoff(hash) {
    if (!hash || hash.length > MAX_FRAGMENT + 1) return null;
    try {
      var raw = new URLSearchParams(hash.replace(/^#/, '')).get('luks_quote');
      if (!raw) return null;
      var p = JSON.parse(raw), allowed = ['version', 'body', 'sku', 'quantity', 'unit', 'source'];
      if (!p || Array.isArray(p) || Object.keys(p).some(function (k) { return allowed.indexOf(k) < 0; })) return null;
      if (p.version !== 1 || p.source !== 'wholesale-catalog' || typeof p.body !== 'string' || !p.body.trim() || p.body.length > MAX_BODY) return null;
      if (p.quantity !== undefined && (!Number.isInteger(p.quantity) || p.quantity < 1 || p.quantity > 99999)) return null;
      if (p.sku !== undefined && (typeof p.sku !== 'string' || !p.sku.trim() || p.sku.length > 200)) return null;
      if (p.unit !== undefined && (typeof p.unit !== 'string' || !p.unit.trim() || p.unit.length > 40)) return null;
      return p;
    } catch (e) { return null; }
  }
  function handoffHref(payload, path) {
    var hash = '#luks_quote=' + encodeURIComponent(JSON.stringify(payload));
    return parseHandoff(hash) ? path + hash : null;
  }
  function productHref(title, variant, quantity, each, path, pack) {
    var p = new URLSearchParams();
    p.set('product', title);
    p.set('sku', variant.sku || '');
    if (variant.title && variant.title !== 'Default Title') p.set('variant', variant.title);
    p.set('quantity', String(quantity));
    if (variant.sku === '5481-BL') p.set('unit', each);
    if (variant.sku === '5481-BL-100') p.set('unit', pack || 'Pack of 100 sleeves');
    return path + '?' + p.toString();
  }
  function init(w) {
    var d = w.document, a = d.querySelector('.li-product-quote-action');
    if (a) {
      var variants;
      try { variants = JSON.parse(a.dataset.variants); } catch (e) { variants = []; }
      var productForm = d.getElementById('cart-form');
      function selected() {
        var id = productForm && productForm.querySelector('[name="id"]');
        return variants.find(function (v) { return String(v.id) === String(id && id.value || a.dataset.selectedId); });
      }
      function updateProduct(initial) {
        var v = selected(), q = productForm && productForm.querySelector('[name="quantity"]');
        if (!v) return;
        if (q && v.sku === '5481-BL') {
          q.min = '100'; q.step = '100';
          if (initial && q.value === '1') q.value = '100';
        }
        if (q && v.sku === '5481-BL-100') { q.min = '1'; q.step = '1'; }
        a.href = productHref(a.dataset.productTitle, v, q && q.value || (v.sku === '5481-BL' ? 100 : 1), a.dataset.each, '/pages/contact-us', a.dataset.pack);
      }
      updateProduct(true);
      if (productForm) productForm.addEventListener('change', function () { updateProduct(false); });
      if (productForm) productForm.addEventListener('submit', function (e) {
        updateProduct(false);
        var q = productForm.querySelector('[name="quantity"]');
        if (q && !q.checkValidity()) { e.preventDefault(); e.stopImmediatePropagation(); q.reportValidity(); }
      }, true);
      a.addEventListener('click', function (e) {
        updateProduct(false);
        var q = productForm && productForm.querySelector('[name="quantity"]');
        if (q && !q.checkValidity()) { e.preventDefault(); q.reportValidity(); }
      });
    }
    var cart = d.querySelector('[data-cart-quote]');
    function refreshCartQuote() {
      if (!cart) return;
      try {
        var invalid = false;
        var items = JSON.parse(cart.dataset.items).map(function (item) {
          var q = Array.from(d.querySelectorAll('.shopify-cart-form [data-line-key]')).find(function (el) { return el.dataset.lineKey === item.key; });
          if (q) {
            if (!q.checkValidity()) invalid = true;
            item.quantity = Number(q.value);
          }
          return item;
        }).filter(function (item) { return item.quantity > 0; });
        var link = cart.querySelector('[data-cart-quote-link]');
        if (invalid || !items.length) {
          link.removeAttribute('href'); link.setAttribute('aria-disabled', 'true');
          cart.querySelector('[data-cart-quote-status]').textContent = cart.dataset.invalidQuantity;
          return;
        }
        var lines = items.map(function (item, i) {
          return (i + 1) + '. ' + (item.sku || '') + ' | ' + item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' | ' + item.variant_title : '') + ' | ' + cart.dataset.quantity + ': ' + item.quantity + ' | ' + cart.dataset.unitLabel + ': ' + (item.sku === '5481-BL' ? cart.dataset.each : item.sku === '5481-BL-100' ? cart.dataset.pack : cart.dataset.unit);
        });
        var payload = { version: 1, source: 'wholesale-catalog', body: cart.dataset.intro + '\n' + lines.join('\n') };
        if (items.length === 1) {
          if (items[0].sku) payload.sku = items[0].sku;
          payload.quantity = items[0].quantity;
          if (items[0].sku === '5481-BL') payload.unit = cart.dataset.each;
          if (items[0].sku === '5481-BL-100') payload.unit = cart.dataset.pack;
        }
        var href = handoffHref(payload, '/pages/contact-us');
        link.href = href || '/pages/contact-us'; link.removeAttribute('aria-disabled');
        cart.querySelector('[data-cart-quote-status]').textContent = href ? '' : cart.dataset.large;
      } catch (e) { cart.querySelector('[data-cart-quote-status]').textContent = cart.dataset.large; }
    }
    refreshCartQuote();
    if (cart) {
      d.addEventListener('input', function (e) { if (e.target.matches('.shopify-cart-form [name="updates[]"]')) refreshCartQuote(); });
      cart.querySelector('[data-cart-quote-link]').addEventListener('click', function (e) { refreshCartQuote(); if (e.currentTarget.getAttribute('aria-disabled') === 'true') e.preventDefault(); });
    }
    d.addEventListener('click', function (e) {
      var button = e.target.closest('.quantity .plus, .quantity .minus');
      if (!button) return;
      var q = button.parentElement.querySelector('input[type="number"]');
      if (!q || Number(q.step) !== 100) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var n = Number(q.value), min = Number(q.min || 0), max = q.max ? Number(q.max) : Infinity;
      var next = button.classList.contains('plus') ? Math.floor(n / 100) * 100 + 100 : Math.ceil(n / 100) * 100 - 100;
      if (next >= min && next <= max) q.value = String(next);
      q.dispatchEvent(new w.Event('input', { bubbles: true }));
      q.dispatchEvent(new w.Event('change', { bubbles: true }));
    }, true);
    var form = d.getElementById('LuksQuoteForm');
    if (!form) return;
    var tools = form.querySelector('[data-quote-tools]'), status = form.querySelector('[data-quote-status]');
    var names = ['li-name', 'li-company', 'li-email', 'li-phone', 'li-category', 'li-buyer', 'li-jurisdiction', 'li-sku', 'li-variant', 'li-multiple', 'li-qty', 'li-unit', 'li-delivery', 'li-receiving', 'li-needed', 'li-message'];
    var key = 'luks-quote-draft-v1', submitted = !!form.querySelector('[data-quote-submitted]');
    function get(id) { return d.getElementById(id); }
    function forget() { try { w.sessionStorage.removeItem(key); } catch (e) {} }
    function save() {
      if (submitted) return;
      var values = {};
      names.forEach(function (id) { var el = get(id); if (el) values[id] = el.type === 'checkbox' ? el.checked : el.value; });
      try { w.sessionStorage.setItem(key, JSON.stringify({ saved: Date.now(), values: values })); } catch (e) {}
    }
    if (submitted) { forget(); return; }
    try {
      var draft = JSON.parse(w.sessionStorage.getItem(key));
      if (draft && Date.now() - draft.saved < 86400000 && draft.values) {
        names.forEach(function (id) {
          var el = get(id), value = draft.values[id];
          if (!el) return;
          if (el.type === 'checkbox' && typeof value === 'boolean') el.checked = value;
          else if (typeof value === 'string' && (!el.value || ['li-name', 'li-email', 'li-message'].indexOf(id) < 0)) el.value = value.slice(0, el.maxLength > 0 ? el.maxLength : 20000);
        });
        status.textContent = tools.dataset.restored;
      } else if (draft) forget();
    } catch (e) { forget(); }
    var p = new URLSearchParams(w.location.search), transferred = parseHandoff(w.location.hash);
    var hasFragment = new URLSearchParams(w.location.hash.replace(/^#/, '')).has('luks_quote');
    if (transferred) {
      get('li-message').value = transferred.body;
      get('li-sku').value = transferred.sku || '';
      get('li-variant').value = '';
      get('li-qty').value = transferred.quantity || '';
      get('li-unit').value = transferred.unit || '';
      get('li-multiple').checked = !transferred.quantity;
      get('li-category').value = 'Other / Multiple categories';
      w.history.replaceState(null, '', w.location.pathname + w.location.search);
    } else if (hasFragment) status.textContent = tools.dataset.invalid;
    else if (p.has('product')) {
      get('li-message').value = p.get('product').slice(0, 20000);
      get('li-sku').value = (p.get('sku') || '').slice(0, 200);
      get('li-variant').value = (p.get('variant') || '').slice(0, 200);
      var qty = Number(p.get('quantity'));
      get('li-qty').value = Number.isInteger(qty) && qty > 0 && qty <= 99999 ? qty : '';
      var unit = p.get('unit') || '';
      get('li-unit').value = unit === 'Default Title' || unit === 'Confirm selling unit' ? '' : unit.slice(0, 80);
      get('li-multiple').checked = false;
      ['product', 'sku', 'variant', 'quantity', 'unit'].forEach(function (key) { p.delete(key); });
      w.history.replaceState(null, '', w.location.pathname + (p.toString() ? '?' + p.toString() : '') + w.location.hash);
    }
    if (p.get('category') === 'drums') {
      get('li-category').value = 'Industrial Packaging & Drums';
      get('li-qty').value = get('li-qty').value || '200';
      get('li-unit').value = 'Drums';
    }
    function requirements() {
      var q = get('li-qty'), u = get('li-unit'), multiple = get('li-multiple').checked;
      var drums = get('li-category').value === 'Industrial Packaging & Drums';
      q.required = u.required = !multiple || drums;
      q.min = drums ? '200' : get('li-sku').value.trim() === '5481-BL' ? '100' : '1';
      q.step = get('li-sku').value.trim() === '5481-BL' ? '100' : '1';
      get('li-buyer').dispatchEvent(new w.Event('change'));
    }
    requirements();
    ['li-multiple', 'li-category', 'li-sku'].forEach(function (id) { get(id).addEventListener('change', requirements); });
    form.addEventListener('input', save);
    form.addEventListener('change', save);
    form.addEventListener('submit', function (e) {
      requirements(); save();
      if (!form.checkValidity()) { e.preventDefault(); form.reportValidity(); }
    });
    tools.querySelector('[data-quote-clear]').addEventListener('click', function () { forget(); form.reset(); requirements(); status.textContent = ''; });
    tools.querySelector('[data-quote-copy]').addEventListener('click', async function () {
      save();
      var text = names.map(function (id) {
        var el = get(id), label = d.querySelector('label[for="' + id + '"]');
        if (!el || !el.value || el.type === 'checkbox') return '';
        return (label ? label.textContent.trim() : id) + ': ' + el.value;
      }).filter(Boolean).join('\n');
      try { await w.navigator.clipboard.writeText(text); status.textContent = tools.dataset.copied; }
      catch (e) {
        var output = get('li-quote-copy'); output.value = text; output.hidden = false;
        tools.querySelector('[data-copy-label]').hidden = false; output.focus(); output.select();
        status.textContent = tools.dataset.selectCopy;
      }
    });
    save();
  }
  return { parseHandoff: parseHandoff, handoffHref: handoffHref, productHref: productHref, init: init };
});
